/**
 * Coincidencia por palabra completa (no substring).
 * "urologia" matchea "urologia pediatrica" / "urologia + andrologia",
 * pero no "neurologia".
 */
export function matchesSpecialityWord(medicalSpeciality, selected) {
  if (!medicalSpeciality || !selected) return false;

  const normalize = (value) =>
    String(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

  const haystack = normalize(medicalSpeciality);
  const needle = normalize(selected);

  if (!haystack || !needle) return false;
  if (haystack === needle) return true;

  const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`(^|[^a-z0-9])${escaped}([^a-z0-9]|$)`);
  return re.test(haystack);
}
